/* eslint-disable */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Card, Form } from "tabler-react";

import { AlertComponent, LoadingButton, MultiSelect } from "../../../component";

import { helper } from "../../../utils/helpers/helper";
import { userActions } from "../../../store/actions/userActions";
import { alertActions } from "../../../store/actions/alertActions";
import { mapActions } from "../../../store/actions";

let defaultState = {
  id: null,
  value: null,
  label: null,
};
let select;
let timeoutTime;

class AccountOverviewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      first_name: "",
      last_name: "",
      username: "",
      email: "",
      subscriptionLevel: "",
      city: "",
      clearCity: false,
      country: "",
      clearCountry: false,
      citiesData: [],
      countryData: "",
      selectElement: [],
      errors: null,
      history: "", // Initialized to  save browser history and redirection
    };
  }

  componentDidMount() {
    this.props.clearAlerts();
    this.props.callCountryAPI();
    let user = this.props.user;
    let subscription = this.props.subscription;
    let localStorageSubscription = JSON.parse(
      localStorage.getItem("subscription_details")
    );
    let checkSubcriptionLevel =
      subscription === null ? localStorageSubscription : subscription;
    this.setState({
      subscriptionLevel:
        checkSubcriptionLevel?.subscription_level !== null
          ? "Level " + checkSubcriptionLevel?.subscription_level
          : "Admin",
    });
    if (user === null) {
      user = JSON.parse(localStorage.getItem("user"));
    }
    this.parseUser(user);
  }

  componentWillUnmount() {
    clearTimeout(timeoutTime);
  }

  parseUser = async (user, e) => {
    const first_name = !!user?.first_name ? user?.first_name : "Test";
    const last_name = !!user?.last_name ? user?.last_name : "User";
    const username = first_name + " " + last_name;
    const userRole = helper.get_user_role(user?.user_type);
    await this.setState({
      user_type: userRole,
      username: username,
      first_name: user?.first_name,
      last_name: user?.last_name,
      email: user?.email,
    });
  };

  handleTextChange = (e) => {
    this.setState({
      // [e.target.name]: e.target.value.replace(/[^\w\s]/gi, ""),
      [e.target.name]: e.target.value.replace(
        /[-!$%^&*()_+|~=`\\#{}\[\]:";'<>?,.\/]/gi,
        ""
      ),
      history: this.props.history,
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      history: this.props.history,
    });
  };

  handleChangeSelect = async (prop) => {
    const { name, value } = prop;
    const { countries } = this.props;
    let city;
    let clearCity;
    let citiesData;
    let updatedValue = value !== null ? value : defaultState;
    let defaultSelectCity = {
      id: null,
      value: null,
      label: "Please select city",
    };
    this.props.clearMapFilters(false);
    if (name === "country") {
      // alert("gnk"+value.label);
      const cities = countries.cities;
      if (value !== null) {
        cities &&
          cities.map(async (cityRecord, idx) => {
            if (cityRecord.id === value.id) {
              citiesData = cityRecord.values;
            }
            return null;
          });
        city = this.state.city;
        citiesData = citiesData;
        clearCity = false;
      } else {
        citiesData = [];
        city = value;
        clearCity = true;
      }
      select = [
        {
          name: "country",
          placeholder: "Country",
          options: this.state.countryData,
          disabled: false,
          cleared: false,
          clearFilters: false,
          handler: this.handleChangeSelect,
          value: value,
        },
        {
          name: "city",
          placeholder: "City",
          options: citiesData,
          disabled: false,
          cleared: true,
          clearFilters: true,
          handler: this.handleChangeSelect,
          value: defaultSelectCity,
          isChild: true,
        },
      ];
      await this.setState(
        {
          [name]: updatedValue,
          clearCity,
          citiesData: citiesData,
          selectElement: select,
        },
        () => {
          this.forceUpdate();
        }
      );
      // await this.setState({ [name]: updatedValue, city, clearCity,  citiesData: citiesData, selectElement: select}, () => {
      //   this.forceUpdate();
      // });
      if (value === null) {
        // this.props.clearMapFilters(true);
      }
    } else {
      select = [
        {
          name: "country",
          placeholder: "Country",
          options: this.state.countryData,
          disabled: false,
          cleared: false,
          clearFilters: false,
          handler: this.handleChangeSelect,
          value: this.state.country,
        },
        {
          name: "city",
          placeholder: "City",
          options: this.state.citiesData,
          disabled: false,
          cleared: false,
          clearFilters: false,
          handler: this.handleChangeSelect,
          value: updatedValue,
        },
      ];
      await this.setState({ [name]: value, selectElement: select });
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    let validationCheck = this.handleValidation();
    let errors = {
      email: "",
      first_name: "",
      last_name: "",
      country: false,
      city: false,
    };
    if (
      validationCheck.email === "" &&
      validationCheck.first_name === "" &&
      validationCheck.last_name === "" &&
      validationCheck.country === "" &&
      validationCheck.city === ""
    ) {
      await this.setState({
        errors: errors,
      });
      this.props.updateProfile(this.state);
      timeoutTime = setTimeout(() => {
        this.props.clearAlerts();
        window.location.reload();
      }, 5000);
    }
  };

  handleValidation = (e) => {
    let values = this.state;
    // same as above, but feel free to move this into a class method now.
    let errors = {
      email: "",
      first_name: "",
      last_name: "",
      country: "",
      city: "",
    };
    if (!values.email) {
      errors.email = "This field is required";
    }
    if (!values.first_name) {
      errors.first_name = "This field is required";
    }
    if (!values.last_name) {
      errors.last_name = "This field is required";
    }
    if (!values.country?.value || !values.country) {
      errors.country = "This field is required";
      errors.city = "This field is required";
    }
    if (!values.city?.value || !values.city) {
      errors.city = "This field is required";
    }
    this.setState({
      errors: errors,
    });
    return errors;
  };
  async componentWillReceiveProps(nextProps) {
    const { countries } = nextProps;
    let user = JSON.parse(localStorage.getItem("user"));
    this.parseUser(user);
    if (this.props.countries !== countries) {
      await this.setState({
        countryData: countries.countries,
      });
      const userCityObject = helper.parse_country(countries, user);
      select = [
        {
          name: "country",
          placeholder: "Country",
          options: this.state.countryData,
          disabled: false,
          cleared: false,
          clearFilters: false,
          handler: this.handleChangeSelect,
          value: userCityObject.country,
        },
        {
          name: "city",
          placeholder: "City",
          options: userCityObject.cities,
          disabled: false,
          cleared: false,
          clearFilters: false,
          handler: this.handleChangeSelect,
          value: userCityObject.city,
        },
      ];
      await this.setState({
        country: userCityObject.country,
        city: userCityObject.city,
        citiesData: userCityObject.cities,
        selectElement: select,
      });
    }
  }
  render() {
    let alertComponent;
    const { alert, isProfileUpdated } = this.props;
    const {
      errors,
      email,
      subscriptionLevel,
      first_name,
      last_name,
      selectElement,
    } = this.state;
    if (alert !== {}) {
      alertComponent = alert.message && alert.type && (
        <AlertComponent alert={alert} auth={false} />
      );
    }
    return (
      <Form className="card" onSubmit={this.handleSubmit}>
        <Card.Body>
          <Card.Title>Edit Profile</Card.Title>
          <Grid.Row>
            <Grid.Col xs={12} sm={12} md={12} lg={12} className="mb-2 ">
              {alertComponent ? alertComponent : null}
            </Grid.Col>
            <Grid.Col xs={12} sm={12} md={12} lg={12} className="mb-2 ">
              <Form.Group
                isRequired
                label="Email address"
                className="mb-2 col col-xs-12 col-sm-12 col-md-12 col-lg-12"
              >
                <Form.Input
                  type="email"
                  name="email"
                  readOnly
                  isRequired
                  placeholder="Email"
                  value={email}
                  onChange={this.handleChange}
                  className="mb-2 "
                  error={errors && errors.email}
                />
              </Form.Group>
            </Grid.Col>
            <Grid.Col xs={12} sm={12} md={12} lg={12} className="mb-2 ">
              <Form.Group
                label="Subscription Level"
                className="mb-2 col col-xs-12 col-sm-12 col-md-12 col-lg-12"
              >
                <Form.Input
                  type="text"
                  name="company"
                  readOnly
                  value={subscriptionLevel}
                  className="mb-2 "
                  placeholder="Subscription Level"
                  onChange={this.handleChange}
                />
              </Form.Group>
            </Grid.Col>
            <Grid.Col xs={12} sm={12} md={12} lg={12} className="mb-2 ">
              <Form.Group
                isRequired
                label="First Name"
                className="mb-2 col col-xs-12 col-sm-12 col-md-12 col-lg-12"
              >
                <Form.Input
                  type="text"
                  name="first_name"
                  className="mb-2 "
                  value={first_name}
                  maxLength={20}
                  placeholder="First Name"
                  onChange={this.handleTextChange}
                  error={errors && errors.first_name}
                />
              </Form.Group>
            </Grid.Col>
            <Grid.Col xs={12} sm={12} md={12} lg={12} className="mb-2 ">
              <Form.Group
                isRequired
                label="Last Name"
                className="mb-2 col col-xs-12 col-sm-12 col-md-12 col-lg-12"
              >
                <Form.Input
                  type="text"
                  name="last_name"
                  className="mb-2 "
                  value={last_name}
                  maxLength={20}
                  placeholder="Last Name"
                  onChange={this.handleTextChange}
                  error={errors && errors.last_name}
                />
              </Form.Group>
            </Grid.Col>
            {selectElement &&
              selectElement.map(function (element, i) {
                return (
                  <Grid.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    key={i}
                    className="mb-2"
                  >
                    <Form.Group
                      isRequired
                      label={element.placeholder}
                      className="mb-2 col col-xs-12 col-sm-12 col-md-12 col-lg-12"
                    >
                      <MultiSelect
                        onChange={element.handler}
                        className={`mb-2 ${element.name}-required`}
                        name={element.name}
                        isDisabled={element.disabled}
                        isCleared={element.cleared}
                        isMultiple={false}
                        options={element.options}
                        value={element.value}
                        placeholder={element.placeholder}
                        error={
                          errors && (errors.country || errors.city)
                            ? true
                            : false
                        }
                        isChild={element.isChild ? true : false}
                      />
                    </Form.Group>
                  </Grid.Col>
                );
              })}
          </Grid.Row>
        </Card.Body>
        <Card.Footer className="text-right">
          <LoadingButton
            loadingState={isProfileUpdated}
            preloadingText="Update Profile"
            loadingText="Updating Profile"
          />
        </Card.Footer>
      </Form>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  const { isProfileUpdated, countries, user, subscription } = state.user;
  return {
    alert,
    user,
    subscription,
    isProfileUpdated,
    countries,
  };
}

const mapDispatchToProps = {
  updateProfile: userActions.updateProfile,
  callCountryAPI: userActions.callCountryAPI,
  errorAlerts: alertActions.error,
  successAlerts: alertActions.success,
  clearAlerts: alertActions.clear,
  clearMapFilters: mapActions.clearMapFilters,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountOverviewPage);
